.root {
  position: fixed;
  inset: 0;
  z-index: var(--z-intro);
  display: grid;
  place-items: center;
  background: var(--color-bg);
  color: var(--color-fg);
  cursor: pointer;
  animation: introFadeIn var(--transition-medium);
}

.closing {
  animation: introFadeOut 320ms steps(4, end) forwards;
}

.crt {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image: repeating-linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.3) 0px,
    rgba(0, 0, 0, 0.3) 1px,
    transparent 1px,
    transparent 3px
  );
  mix-blend-mode: multiply;
}

.content {
  position: relative;
  text-align: center;
  padding: var(--space-5);
  max-width: 90vw;
}

.boot {
  margin: 0 0 var(--space-5);
  font-family: var(--font-display);
  font-size: 0.625rem;
  letter-spacing: var(--letter-spacing-display);
  color: var(--color-accent);
  animation: bootType 1.6s steps(20, end);
}

.title {
  font-family: var(--font-display);
  font-size: clamp(1.5rem, 6vw, 3rem);
  letter-spacing: var(--letter-spacing-display);
  color: var(--color-accent);
  margin: 0 0 var(--space-3);
  text-shadow: 4px 4px 0 var(--color-magenta);
}

.subtitle {
  font-family: var(--font-display);
  font-size: clamp(0.625rem, 2vw, 0.875rem);
  letter-spacing: var(--letter-spacing-display);
  color: var(--color-fg);
  margin: 0 0 var(--space-7);
}

.prompt {
  margin: 0 0 var(--space-3);
  font-family: var(--font-display);
  font-size: clamp(0.875rem, 3vw, 1.25rem);
  letter-spacing: var(--letter-spacing-display);
  color: var(--color-fg);
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
}

.promptText {
  animation: promptBlink 1s steps(2, end) infinite;
}

.cursor {
  color: var(--color-accent);
  animation: cursorBlink 0.7s steps(2, end) infinite;
}

.hint {
  margin: 0;
  font-family: var(--font-body);
  font-size: var(--font-size-body-sm);
  color: var(--color-fg-muted);
}

@keyframes introFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes introFadeOut {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(1.04);
  }
}

@keyframes promptBlink {
  0%,
  49% {
    opacity: 1;
  }
  50%,
  100% {
    opacity: 0.35;
  }
}

@keyframes cursorBlink {
  0%,
  49% {
    opacity: 1;
  }
  50%,
  100% {
    opacity: 0;
  }
}

@keyframes bootType {
  from {
    clip-path: inset(0 100% 0 0);
  }
  to {
    clip-path: inset(0 0 0 0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .root,
  .closing {
    animation: none;
  }
  .promptText,
  .cursor {
    animation: none;
  }
  .boot {
    animation: none;
  }
}
